import Bacon from 'baconjs';
import $ from 'jquery';
import { isValidEmail } from 'scripts/tools/validation';
import * as TagManager from 'scripts/components/analytics/tagManagerApi';

export const init = (settings) => {
  const $cardContainer = $(settings.cardContainerSelector);
  const validationRules = [
    {
      inputGroupSelector: settings.firstNameInputGroupSelector,
      inputSelector: settings.firstNameInputSelector,
      rulePredicate: value => value !== '',
    },
    {
      inputGroupSelector: settings.lastNameInputGroupSelector,
      inputSelector: settings.lastNameInputSelector,
      rulePredicate: value => value !== '',
    },
    {
      inputGroupSelector: settings.emailInputGroupSelector,
      inputSelector: settings.emailInputSelector,
      rulePredicate: value => value && (isValidEmail(value)),
    },
  ];

  const setValidationState = ($element, isValid) => {
    if (isValid) {
      $element.addClass('has-success');
      $element.removeClass('has-error');
    } else {
      $element.addClass('has-error');
      $($element).removeClass('has-success');
    }
  };

  const pushToTagManager = (metadata) => {
    TagManager.push({
      'event': metadata.event,
    });
  };

  const validationStreamFactory = (validationRule) => {
    Bacon.fromEvent($cardContainer.find(validationRule.inputSelector), 'change')
      .map(e => validationRule.rulePredicate(e.target.value))
      .skipDuplicates()
      .onValue(result => {
        // Update validation rule with the validation result
        validationRule.isValid = result;
        // Update state in GUI
        setValidationState($cardContainer.find(validationRule.inputGroupSelector), validationRule.isValid);
      });
  };

  const postAktivNewsLetterForm = () => {
    return $.post('/api/aktivnewsletter/newsletterform', {
      firstname: $cardContainer.find(settings.firstNameInputSelector).val(),
      lastname: $cardContainer.find(settings.lastNameInputSelector).val(),
      email: $cardContainer.find(settings.emailInputSelector).val(),
      concentType: $cardContainer.find(settings.concentType).val()
    });
  };

  validationRules.map(validationStreamFactory);
  const $button = $cardContainer.find(settings.submitButtonSelector);
  const $fields = $cardContainer.find(settings.fieldsContainerSelector);
  const $feedbackMsg = $cardContainer.find(settings.feedbackContainerSelector);
  const $errorMsg = $cardContainer.find(settings.errorMessageContainerSelector);

  const buttonText = $button.text();
  const buttonBusyText = $button.attr('data-busy-text');

  $cardContainer.on('submit', 'form', (event) => {
    event.preventDefault();
    // Trigger change to re-validate inputs
    for (const rule of validationRules) {
      $cardContainer.find(`${rule.inputGroupSelector} input`).change();
    }
    const isAllValid = validationRules.every(r => r.isValid);
    if (isAllValid) {
      $button.attr('disabled', 'disabled');
      $button.text(buttonBusyText);
      $errorMsg.hide();

      postAktivNewsLetterForm().then(() => {
        pushToTagManager(settings.tagManagerMetaData);
        $fields.hide();
        $feedbackMsg.show();
        $button.hide();
      }, () => {
        $errorMsg.show();
        $button.removeAttr('disabled');
        $button.text(buttonText);
      });
    }
  });
};
